export default __webpack_public_path__ + "static/media/vidro2.45b26413.jpg";